import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Calculator from "@/pages/Calculator";
import Encyclopedia from "@/pages/Encyclopedia";
import Genetics101 from "@/pages/Genetics101";
import Pro from "@/pages/Pro";
import Success from "@/pages/Success";
import Admin from "@/pages/Admin";
import Flock from "@/pages/Flock";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="calculator" element={<Calculator />} />
            <Route path="flock" element={<Flock />} />
            <Route path="encyclopedia" element={<Encyclopedia />} />
            <Route path="genetics-101" element={<Genetics101 />} />
            <Route path="pro" element={<Pro />} />
            <Route path="pro/success" element={<Success />} />
            <Route path="admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" />
    </div>
  );
}

export default App;
